import { isTestEnvironment, useAuth } from '@spotify/confidence-core-react';

type AppRedirectResult =
  | { shouldRedirect: false }
  | { shouldRedirect: true; targetUrl: string };

const SLINGSHOT_HOSTNAME_PATTERN =
  /^konfidens-konfidens-standalone-web-app-\d+-\w+\.services\.guc3\.spotify\.net$/;

export function useAppRedirect(preferredUrl: string): AppRedirectResult {
  const { orgName } = useAuth();

  if (
    !orgName ||
    !preferredUrl ||
    preferredUrl === window.location.origin ||
    process.env.NODE_ENV === 'development' ||
    isTestEnvironment() ||
    SLINGSHOT_HOSTNAME_PATTERN.test(window.location.hostname)
  ) {
    return { shouldRedirect: false };
  }

  return {
    shouldRedirect: true,
    targetUrl: preferredUrl,
  };
}
